var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"Navbar"},[_vm._m(0),_c('li',[_vm._v("KingsChat")]),_c('li',{staticClass:"Navbar__hamburger",on:{"click":function($event){return _vm.toggleNav()}}},[_c('div'),_c('div'),_c('div')])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('li',[_c('img',{attrs:{"src":require("@/assets/img/kc-logo.png")}})])
}]

export { render, staticRenderFns }